'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import FacetFilter from './FacetFilter';
import { FacetGroupName, JobSearchFacets } from '../api/jobs';
import { Dictionaries } from '../i18n/i18n-config';

function JobFacetFilters({
  facets,
  dictionary,
  open,
}: {
  facets: JobSearchFacets;
  dictionary: Partial<Dictionaries>;
  open?: boolean;
}) {
  if (!facets) return null;

  return (
    <>
      {Object.entries(facets).map(([facetGroup, facet], i) => (
        <FacetFilter
          key={`facetFilters_${facetGroup}_${i}`}
          dictionary={dictionary}
          facetGroup={facetGroup as FacetGroupName}
          facets={facet}
          open={open}
        />
      ))}
    </>
  );
}

export default JobFacetFilters;
